import React, { useState } from 'react';
import Tooltip from 'components/Core/Tooltip/Tooltip';
import dangerousGoodsIcon from 'styles/assets/images/dangerous_class.png';

const DangerousGoodsIcon = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [parentElement, setParentElement] = useState(null);

  return (
    <div
      className="ag-list__image-cell__type-icon-container"
      style={{
        top: '30px',
        left: 0,
        transform: 'translate(-25%, -25%)',
      }}
    >
      <Tooltip
        isVisible={isTooltipVisible}
        tooltipPosition="right"
        labelValue="produit dangereux"
        parentElement={parentElement}
      />
      <img
        src={dangerousGoodsIcon}
        alt="produit dangereux"
        style={{
          width: '20px',
          height: '20px',
          cursor: 'pointer',
        }}
        onMouseEnter={(event) => {
          setIsTooltipVisible(true);
          setParentElement(event.target);
        }}
        onMouseLeave={() => {
          setIsTooltipVisible(false);
        }}
      />
    </div>
  );
};

export default DangerousGoodsIcon;
